import * as React from 'react';
import { FC, useCallback, useEffect, useMemo } from 'react';

import Measure from 'react-measure';
import styled from 'styled-components';

import { useRoutesDisplayBottomService as useRoutesDisplayServiceNotification } from 'components/bottom-service-mode/hooks/use-routes-display-bottom-service';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useUIContext } from 'state/ui';

import { useServiceModeNotification } from './hooks/use-service-mode-notification';
import { TopServiceModeNotificationView } from './top-service-mode-notification.view';
import { ITopServiceModeNotificationProps } from './types';

const StickyServiceNotification = styled(TopServiceModeNotificationView)`
  z-index: ${Styles.zIndex.overlay + 100};
  width: 100%;
`;

/**
 *
 * TopServiceModeNotification purpose
 *
 */
const TopServiceModeNotification: FC<ITopServiceModeNotificationProps> = () => {
  const enableTopServiceMode = useFlag(LaunchDarklyFlag.ENABLE_TOP_SERVICE_MODE);
  const enableBottomServiceMode = useFlag(LaunchDarklyFlag.ENABLE_BOTTOM_SERVICE_MODE);
  const { updateBottomServiceDimensions: updateServiceNotificationDimensions } = useUIContext();
  const showServiceNotificationOnRoutes = useRoutesDisplayServiceNotification();
  const topServiceModeNotificationDetails = useServiceModeNotification();

  const isDisplayServiceNotification = useMemo(
    () => enableTopServiceMode && !enableBottomServiceMode && showServiceNotificationOnRoutes,
    [enableBottomServiceMode, enableTopServiceMode, showServiceNotificationOnRoutes]
  );

  const handleResize = useCallback(
    contentRect => {
      if (contentRect.bounds) {
        updateServiceNotificationDimensions({
          top: contentRect.bounds.top,
          left: contentRect.bounds.left,
          width: contentRect.bounds.width,
          height: contentRect.bounds.height,
        });
      }
    },
    [updateServiceNotificationDimensions]
  );

  useEffect(() => {
    if (!isDisplayServiceNotification) {
      updateServiceNotificationDimensions({
        top: 0,
        left: 0,
        width: 0,
        height: 0,
      });
    }
  }, [isDisplayServiceNotification, updateServiceNotificationDimensions]);

  if (!isDisplayServiceNotification) {
    return null;
  }

  return (
    topServiceModeNotificationDetails && (
      <Measure bounds onResize={handleResize}>
        {({ measureRef }) => (
          <StickyServiceNotification ref={measureRef} {...topServiceModeNotificationDetails} />
        )}
      </Measure>
      // <CancellationModal /> Logic will be done in the FAB button work
    )
  );
};

export default TopServiceModeNotification;
